import React, { useEffect, useRef, useState } from 'react';
import { COLORS, FONT } from '../theme';
import { useAuth } from '../context/AuthContext';
import { usePageTitleContext } from '../context/PageTitleContext';

function formatarDataHoje() {
  const texto = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

const ITENS_CONFIGURACOES = [
  { chave: 'empresas', titulo: 'Empresas' },
  { chave: 'depositos', titulo: 'Depósitos' },
  { chave: 'regioes-entrega', titulo: 'Regiões de Entrega' },
  { chave: 'dados-bancarios', titulo: 'Dados Bancários e Pix' },
  { chave: 'auditoria', titulo: 'Log de Auditoria', perfis: ['admin', 'gestor'] }
];

export default function TopBar({ tituloPadrao, onNavegar }) {
  const { usuario, perfil, empresas, empresaAtualId, trocarEmpresa, logout } = useAuth();
  const { titulo: tituloOverride } = usePageTitleContext();
  const titulo = tituloOverride || tituloPadrao;
  const iniciais = usuario?.nome ? usuario.nome.trim().charAt(0).toUpperCase() : '';

  const [menuAberto, setMenuAberto] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function aoClicarFora(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuAberto(false);
    }
    document.addEventListener('mousedown', aoClicarFora);
    return () => document.removeEventListener('mousedown', aoClicarFora);
  }, []);

  const sair = () => {
    if (window.confirm('Deseja realmente sair?')) logout();
  };

  const irPara = (chave) => {
    setMenuAberto(false);
    if (onNavegar) onNavegar(chave);
  };

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 20, height: 68, boxSizing: 'border-box',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 28px', background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${COLORS.border}`, fontFamily: FONT
    }}>
      <span style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, lineHeight: 1 }}>{titulo}</span>

      <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
        <img src="/logo-coren-pt.png" alt="Coren" style={{ height: 34, objectFit: 'contain', display: 'block' }} />

        {empresas.length > 1 && (
          <select
            value={empresaAtualId || ''}
            onChange={e => trocarEmpresa(Number(e.target.value))}
            style={{
              border: `1.5px solid ${COLORS.border}`, borderRadius: 8, padding: '6px 9px',
              fontSize: 13, fontWeight: 600, color: COLORS.text, background: COLORS.bg, fontFamily: FONT
            }}
          >
            {empresas.map(e => <option key={e.id} value={e.id}>{e.nome}</option>)}
          </select>
        )}

        <span style={{ fontSize: 13, color: COLORS.textMid, lineHeight: 1 }}>{formatarDataHoje()}</span>

        <div style={{ width: 1, height: 26, background: COLORS.border }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
          <div style={{
            width: 32, height: 32, borderRadius: '50%', background: COLORS.primaryBg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: COLORS.primary, fontWeight: 700, fontSize: 13, flexShrink: 0
          }}>
            {iniciais}
          </div>
          <div style={{ lineHeight: 1.25 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>{usuario?.nome}</div>
            <div style={{ fontSize: 11, color: COLORS.textLight, textTransform: 'capitalize' }}>{perfil}</div>
          </div>
          <button
            onClick={sair}
            title="Sair"
            style={{
              width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'none', border: 'none', cursor: 'pointer', color: COLORS.textLight, marginLeft: 2
            }}
          >
            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <path d="M16 17l5-5-5-5" />
              <path d="M21 12H9" />
            </svg>
          </button>
        </div>

        <div ref={menuRef} style={{ position: 'relative' }}>
          <button
            onClick={() => setMenuAberto(a => !a)}
            title="Configurações"
            style={{
              width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: menuAberto ? COLORS.primaryBg : 'none', border: `1px solid ${COLORS.border}`, borderRadius: 8, cursor: 'pointer', color: COLORS.textMid
            }}
          >
            <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </button>

          {menuAberto && (
            <div style={{
              position: 'absolute', top: 40, right: 0, minWidth: 180, background: COLORS.surface,
              border: `1px solid ${COLORS.border}`, borderRadius: 10, boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
              padding: 6, zIndex: 30
            }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.textLight, textTransform: 'uppercase', letterSpacing: '0.04em', padding: '6px 10px' }}>
                Configurações
              </div>
              {ITENS_CONFIGURACOES.filter(item => !item.perfis || item.perfis.includes(perfil)).map(item => (
                <button
                  key={item.chave}
                  onClick={() => irPara(item.chave)}
                  style={{
                    display: 'block', width: '100%', textAlign: 'left', padding: '8px 10px', borderRadius: 7,
                    border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: COLORS.text, fontFamily: FONT
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = COLORS.bg; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
                >
                  {item.titulo}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
